// Libs
import axios from "../configRequest";
// Data
import { I_AXIOS } from "../configRequest.model";
import { I_apiApply } from "./apiApply.type";

const apiApply = async (data: I_apiApply) => {
    const fetchData = await axios.post(I_AXIOS.SPACE_API_URL + "/apply", data);
    return fetchData.data;
};

export default apiApply;
